import apiClient from './api_client_requests';

export default async (payload) => {
    let result = await apiClient.apiMethod({
        method: 'SetEntryFlashGameFlag',
        args: {
            promotion: 'celebration',
            flag: 2,
            game_id: '1338',
            entry_id: payload.entry_id,
        },
    });

    return result;
};
